var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconBoard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 18,
    viewBox: "0 0 22 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.4 0A4.451 4.451 0 000 4.5v9A4.451 4.451 0 004.4 18h13.2a4.451 4.451 0 004.4-4.5v-9A4.451 4.451 0 0017.6 0zm8.8 2.25H8.8v13.5h4.4zm2.2 0v13.5h2.2a2.225 2.225 0 002.2-2.25v-9a2.225 2.225 0 00-2.2-2.25zm-11 13.5h2.2V2.25H4.4A2.225 2.225 0 002.2 4.5v9a2.225 2.225 0 002.2 2.25z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}

export default SvgIconBoard;